import { render, staticRenderFns } from "./StripeBtn.vue?vue&type=template&id=123da3c4&"
import script from "./StripeBtn.vue?vue&type=script&lang=js&"
export * from "./StripeBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports